/** Maps token-counter methodName values to i18n key suffixes under organisationManagement.costs.methods. */
export const COST_METHOD_I18N_KEYS: Record<string, string> = {
  'de.liks.platformchat.control.PlatformChatAIService.chat': 'platformChat',
  'de.liks.platformchat.control.PlatformChatAIService.streamChat':
    'platformChatStream',
  'de.liks.platformchat.control.PlatformChatWebSearchAIService.chat':
    'platformChatWebSearch',
  'de.liks.platformchat.control.PlatformChatWebSearchAIService.streamChat':
    'platformChatWebSearchStream',
  'de.liks.platformchat.control.PlatformChatTitleAIService.generateTitle':
    'platformChatTitle',
  'de.liks.chatbot.control.ChatAIService.chat': 'chatbot',
  'de.liks.chatbot.control.ChatAIService.streamChat': 'chatbotStream',
  'de.liks.remote.ImageAiService.getTextFromImage': 'imageToText',
  'de.liks.remote.AudioAiService.getTextFromAudio': 'audioToText',
  'de.liks.remote.AudioAiService.getTextFromAudioInLanguage': 'audioToText',
  'de.liks.remote.VideoAiService.getTextFromVideo': 'videoToText',
  'de.liks.remote.DocumentAiService.getTextFromPdf': 'documentEmbedding',
  'embedding.query': 'embeddingQuery',
  'embedding.store': 'embeddingStore',
  'image.generation': 'imageGeneration',
};

export function resolveCostMethodLabel(
  methodName: string,
  translate: (key: string) => string,
): string {
  const keySuffix = COST_METHOD_I18N_KEYS[methodName];
  if (!keySuffix) {
    return methodName;
  }
  return translate(`organisationManagement.costs.methods.${keySuffix}`);
}
